import { useQuery } from '@tanstack/react-query';

import axiosInstance from 'src/utils/axios';

const getTenants = async () => {
  const response = await axiosInstance.get('/tenants');
  return response.data;
};

export function useGetTenants(isAuthTokenSet: boolean) {
  const { data } = useQuery({
    queryKey: ['tenants'],
    queryFn: getTenants,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isAuthTokenSet,
  });

  return { tenants: data };
}
